import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, Fragment } from "react";

export type ButtonCloseContactprops = {
  onClick?: () => void;
};

export const ButtonCloseContact: FC<ButtonCloseContactprops> = ({
  onClick,
}) => {
  return (
    <Fragment>
      <button
        type="button"
        onClick={onClick}
        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
      >
        <span className="absolute -inset-2.5" />
        <span className="sr-only">Close panel</span>
        <FontAwesomeIcon
          icon={faXmark}
          aria-hidden="true"
          className="h-6 w-6"
        />
      </button>
    </Fragment>
  );
};
